import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import './filters';

import './helpers/touchevents';

// Load all svgs in `assets/svg` with svg-sprite-loader
const svgAssets = require.context(
  '!svg-sprite-loader!@/assets/svg',
  false,
  /.*\.svg$/
);
svgAssets.keys().forEach(svgAssets);

//
router.beforeEach((to, from, next) => {
  if (to.meta.title) document.title = to.meta.title;
  next();
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
